<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Manpower Budgeting</h5>
  </div>
  <div id="mainContent" class="container">
    <div id="budgetForm" class="pt-4 pb-4">
      <form [formGroup]="budgetForm">
        <div class="card">
          <div class="card-header">
            <label class="mb-0">Create Budget</label>
          </div>
          <div class="card card-body">
            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Financial Year:</label>
                  <select class="form-control form-control-xs" [id]="'financialYear'" [name]="'financialYear'"
                    type="text" class="form-control form-control-xs" formControlName="financialYear"
                    (change)="onChangeFinancialYear()" [class.is-invalid]="formErrors.financialYear && formSubmitted"
                    matTooltip="{{ formErrors.financialYear }}" matTooltipPosition="above"
                    matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Year</option>
                    <option *ngFor="let fy of financialYearList" [ngValue]="fy">
                      {{ fy.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Branch:</label>
                  <select class="form-control form-control-xs" [id]="'branch'" [name]="'branch'" type="text"
                    class="form-control form-control-xs" (change)="
                    loadAssignedPartnerForBranch(budgetForm.get('branch').value)
                  " formControlName="branch" [class.is-invalid]="formErrors.branch && formSubmitted"
                    matTooltip="{{ formErrors.branch }}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Branch</option>
                    <option *ngFor="let branch of branchList" [ngValue]="branch">
                      {{ branch.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Partner Assigned:</label>
                  <select class="form-control form-control-xs" [id]="'assignedPartner'" [name]="'assignedPartner'"
                    type="text" class="form-control form-control-xs" (change)="
                    loadClientsForPartner(
                      budgetForm.get('assignedPartner').value
                    )
                  " formControlName="assignedPartner" [class.is-invalid]="
                    formErrors.assignedPartner && formSubmitted
                  " matTooltip="{{ formErrors.assignedPartner }}" matTooltipPosition="above"
                    matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Partner</option>
                    <option *ngFor="let partner of assignedPartnerList" [ngValue]="partner">
                      {{ partner.firstName }} {{ partner.middleName }}
                      {{ partner.lastName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Client:</label>
                  <select class="form-control form-control-xs" [id]="'client'" [name]="'client'" type="text"
                    class="form-control form-control-xs" (change)="
                    loadClientAssignment(
                      budgetForm.get('client').value,
                      budgetForm.get('assignedPartner').value,
                      budgetForm.get('financialYear').value
                    )
                  " formControlName="client" [class.is-invalid]="formErrors.client && formSubmitted"
                    matTooltip="{{ formErrors.client }}" matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Client</option>
                    <option *ngFor="let client of clientList" [ngValue]="client">
                      {{ client.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Assignment:</label>
                  <select class="form-control form-control-xs" [id]="'assignment'" [name]="'assignment'" type="text"
                    class="form-control form-control-xs" (change)="checkIfBudgetExist()" formControlName="assignment"
                    [class.is-invalid]="formErrors.assignment && formSubmitted" matTooltip="{{ formErrors.assignment }}"
                    matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Assignment</option>
                    <option *ngFor="let assignment of assignmentList" [ngValue]="assignment">
                      {{ assignment.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Assignment Fees:</label>
                  <input class="form-control form-control-xs" type="text" name="assignmentFees" id="assignmentFees"
                    formControlName="assignmentFees" [class.is-invalid]="
                    formErrors.assignmentFees && formSubmitted
                  " matTooltip="{{ formErrors.assignmentFees }}" matTooltipPosition="above"
                    matTooltipClass="warn-tooltip" (change)="onAssignmentFeesChange()" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Role:</label>
                  <select class="form-control form-control-xs" [id]="'role'" [name]="'role'" type="text"
                    [compareWith]="compareById" formControlName="role"
                    [class.is-invalid]="formErrors.role && formSubmitted" matTooltip="{{ formErrors.role }}"
                    matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [ngValue]="null">Select Role</option>
                    <option *ngFor="let role of roleList" [ngValue]="role">
                      {{ role.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Service Vertical:</label>
                  <select class="form-control form-control-xs" [id]="'serviceVertical'" [name]="'serviceVertical'"
                    [compareWith]="compareById" type="text" (change)="loadEmployeesForServiceVerticalAndRoles()"
                    formControlName="serviceVertical" matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [ngValue]="null">Select Service Vertical</option>
                    <option *ngFor="let serviceVertical of serviceVerticalList" [ngValue]="serviceVertical">
                      {{ serviceVertical.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group mb-0">
                  <label class="mb-0">Select Employee:</label>
                  <select class="form-control form-control-xs" [id]="'employee'" [name]="'employee'" type="text"
                    class="form-control form-control-xs" formControlName="employee"
                    [class.is-invalid]="formErrors.employee && formSubmitted" matTooltip="{{ formErrors.employee }}"
                    matTooltipPosition="above" matTooltipClass="warn-tooltip">
                    <option [value]="null">Select Employee</option>
                    <option *ngFor="let employee of employeeList" [ngValue]="employee">
                      {{ employee.firstName }} {{ employee.middleName }}
                      {{ employee.lastName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <button type="button" class="btn btn-xs btn-theme mt-4" (click)="addBudgetBtnClick()"
                  [disabled]="budgetForm.invalid">
                  <i class="fa fa-plus-square-o" aria-hidden="true"></i> ADD
                </button>
              </div>
            </div>
            <br />
            <!-- -->
            <div class="" *ngIf="budgetForm.get('budgetDetails').value.length > 0">
              <table width="100%">
                <!-- <thead class="">
                <tr>
                  <th style="width: 10%;">Role</th>
                  <th style="width: 40%;">Employee</th>
                  <th style="width: 10%;">Standard Rate</th>
                  <th style="width: 10%;">Man Days</th>
                  <th style="width: 6%;">Count</th>
                  <th style="width: 10%;">Total Man Days</th>
                  <th style="width: 10%;">Cost</th>
                  <th style="width: 15%;">Start Date</th>
                  <th style="width: 15%;">End Date</th>
                  <th style="width: 4%;">Action</th>
                </tr>
              </thead> -->
                <tbody>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table width="100%" class="bg-lightgray">
                        <tr>
                          <th style="width: 10%">Role</th>
                          <th style="width: 20%">Service Vertical</th>
                          <th style="width: 20%">Employee</th>
                          <th style="width: 10%">Standard Rate</th>
                          <th style="width: 10%">Man Days</th>
                          <th style="width: 6%">Count</th>
                          <th style="width: 10%; text-align: right">
                            Total Man Days
                          </th>
                          <th style="width: 10%; text-align: right">Cost</th>
                          <th style="width: 4%"></th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table width="100%" formArrayName="budgetDetails" *ngFor="
                        let budgetDetail of budgetForm.get('budgetDetails')
                          .controls;
                        let i = index;
                        let first = first
                      ">
                        <tr [formGroupName]="i">
                          <td style="width: 10%">
                            {{ budgetDetail.value.role.name }}
                          </td>
                          <td style="width: 20%">
                            {{ budgetDetail.value.serviceVertical?.name ? budgetDetail.value.serviceVertical.name : ''
                            }}
                          </td>
                          <td style="width: 20%">
                            {{
                            budgetDetail.value.user == null
                            ? ""
                            : budgetDetail.value.user.firstName
                            }}
                            {{
                            budgetDetail.value.user == null
                            ? ""
                            : budgetDetail.value.user.middleName
                            }}
                            {{
                            budgetDetail.value.user == null
                            ? ""
                            : budgetDetail.value.user.lastName
                            }}
                          </td>
                          <!-- <td style="width: 20%">
                      {{
                      budgetDetail.value.user == null
                      ? ""
                      : budgetDetail.value.user.firstName
                      }}
                      {{
                      budgetDetail.value.user == null
                      ? ""
                      : budgetDetail.value.user.middleName
                      }}
                      {{
                      budgetDetail.value.user == null
                      ? ""
                      : budgetDetail.value.user.lastName
                      }}
                    </td> -->
                          <td style="width: 10%">
                            <input [id]="'standardRate_' + i" [name]="'standardRate_' + i" type="number"
                              class="form-control form-control-xs" style="text-align: right"
                              formControlName="standardRate" matTooltipPosition="above" min="0" />
                          </td>
                          <td style="width: 10%">
                            <input [id]="'budgetedDays_' + i" (blur)="clickOnManyDay(budgetDetail, i)"
                              [name]="'budgetedDays_' + i" type="number" class="form-control form-control-xs"
                              style="text-align: right" formControlName="budgetedDays" matTooltipPosition="above"
                              min="0" />
                          </td>
                          <td style="width: 6%" *ngIf="budgetDetail.value.role.name == 'Article'">
                            <input [id]="'count_' + i" [name]="'count_' + i" type="number"
                              class="form-control form-control-xs" style="text-align: right" formControlName="count"
                              matTooltipPosition="above" min="1" (blur)="onCountClick()" />
                          </td>
                          <td style="width: 6%; text-align: end" *ngIf="budgetDetail.value.role.name != 'Article'">
                            {{ budgetDetail.value.count }}
                          </td>
                          <!-- <td style="width: 6%;">
                          <input [id]="'count_'+i" [name]="'count_'+i" type="number" class="form-control form-control-xs"  style="text-align:right;" formControlName="count" matTooltipPosition="above" min="1">
                        </td> -->
                          <td style="width: 10%; text-align: right">
                            {{
                            budgetDetail.value.budgetedDays *
                            budgetDetail.value.count
                            }}
                          </td>
                          <td style="width: 10%; text-align: right">
                            {{
                            budgetDetail.value.standardRate *
                            budgetDetail.value.count *
                            budgetDetail.value.budgetedDays
                            }}
                          </td>
                          <!-- <td style="width: 15%;">
                          <div class="input-group">
                            <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate"
                            formControlName="fromDate" ngbDatepicker #fromDate="ngbDatepicker"
                            [class.is-invalid]="(budgetDetail.get('fromDate').errors?.required || budgetDetail.get('fromDate').errors?.incorrect)  && formSubmitted">
                            <div class="input-group-append">
                            <button class="btn btn-outline-theme calendar" (click)="fromDate.toggle()" type="button"></button>
                            </div>
                          </div>
                        </td> -->
                          <!--  (change)="onDateChangedInBudgetDetail(i)" -->
                          <!-- <td style="width: 15%;">
                          <div class="input-group">
                            <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="toDate"
                            formControlName="toDate" ngbDatepicker #toDate="ngbDatepicker"
                            [class.is-invalid]="(budgetDetail.get('toDate').errors?.required || budgetDetail.get('toDate').errors?.incorrect) && formSubmitted">
                            <div class="input-group-append">
                            <button class="btn btn-outline-theme calendar" (click)="toDate.toggle()" type="button"></button>
                            </div>
                          </div>
                        </td> -->
                          <td style="width: 4%; text-align: right">
                            <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeBudget(i)">
                              <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="10" style="border: none; padding: 0px">
                      <table width="100%">
                        <tr>
                          <th style="width: 10%">Total</th>
                          <th style="width: 40%"></th>
                          <th style="width: 10%"></th>
                          <th style="width: 10%"></th>
                          <th style="width: 6%"></th>
                          <th style="width: 10%"></th>
                          <th style="width: 10%; text-align: right">
                            {{ getTotalCost() }}
                          </th>
                          <th style="width: 4%"></th>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- <div class="card card-body" >
              <div class="col-md-12" >
                <div class="row">
                  <div class="col-sm-1" >
                    <label for="" class="mb-0">Role</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Employee</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Standard Rate</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Man Days</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Count</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Total Man Days</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Cost</label>
                  </div>
                  <div class="col-sm-2">
                    <label for="" class="mb-0">Start Date</label>
                  </div>
                  <div class="col-sm-2">
                    <label for="" class="mb-0">End Date</label>
                  </div>
                  <div class="col-sm-1">
                    <label for="" class="mb-0">Action</label>
                  </div>
                </div>
              </div>
              <div class="col-md-12" formArrayName="budgetDetails"  *ngFor="let budgetDetail of budgetForm.get('budgetDetails').controls; let i = index;let first = first;">
                <div class="row mb-1" [formGroupName]="i" >
                    <div class="col-sm-1" >
                      {{budgetDetail.value.role.name}}
                    </div>
                    <div class="col-sm-1" >
                      {{ budgetDetail.value.user.firstName }} {{ budgetDetail.value.user.middleName }} {{ budgetDetail.value.user.lastName }}
                    </div>
                    <div class="col-sm-1" >
                      <input [id]="'standardRate_'+i" [name]="'standardRate_'+i" type="number" class="form-control form-control-xs" formControlName="standardRate" matTooltipPosition="above" min="0">
                    </div>
                    <div class="col-sm-1" >
                      <input [id]="'budgetedDays_'+i" [name]="'budgetedDays_'+i" type="number" class="form-control form-control-xs" formControlName="budgetedDays" matTooltipPosition="above" min="0">
                    </div>
                    <div class="col-sm-1" >
                      <input [id]="'count_'+i" [name]="'count_'+i" type="number" class="form-control form-control-xs" formControlName="count" matTooltipPosition="above" min="1">
                    </div>
                    <div class="col-sm-1" ></div>
                    <div class="col-sm-1" ></div>
                    <div class="col-sm-2" >
                      <div class="input-group">
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="startDate"
                        formControlName="startDate" ngbDatepicker #startDate="ngbDatepicker"
                        [class.is-invalid]="budgetDetail.get('startDate').errors?.required  && formSubmitted">
                        <div class="input-group-append">
                        <button class="btn btn-outline-theme calendar" (click)="startDate.toggle()" type="button"></button>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="input-group">
                        <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="endDate"
                        formControlName="endDate" ngbDatepicker #endDate="ngbDatepicker"
                        [class.is-invalid]="budgetDetail.get('endDate').errors?.required && formSubmitted">
                        <div class="input-group-append">
                        <button class="btn btn-outline-theme calendar" (click)="endDate.toggle()" type="button"></button>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-1">
                      <button  type="button" class="btn btn-sm btn-outline-danger " (click)="removeBudget(i)">
                        <i class="fa fa-times" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
              </div>
            </div> -->
            </div>
            <br />
            <div class="row" *ngIf="budgetForm.valid">
              <div class="col-md-2 offset-md-8">
                <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="cancel()">
                  Cancel
                </button>
              </div>
              <div class="col-md-2">
                <button *ngIf="formStatus == 'add'" type="button" class="btn btn-sm btn-block btn-theme"
                  (click)="onSaveClick()">
                  Save
                </button>
                <button *ngIf="formStatus == 'edit'" type="button" class="btn btn-sm btn-block btn-theme"
                  (click)="onUpdateClick()">
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>